import { useState, useEffect, useCallback } from 'react';
import { isApiError } from '@aiptyg/types';
import * as assignmentsService from '../services/assignments.service';
import type { AssignmentDTO } from '../types/assignments.types';

export function useTaskAssignments(taskId: number | undefined) {
  const [items, setItems] = useState<AssignmentDTO[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!taskId) return;
    setLoading(true);
    setError(null);
    try {
      const result = await assignmentsService.listAssignments({
        page: 1,
        pageSize: 10,
        marketId: '',
        status: '',
        taskId: String(taskId),
        userId: '',
        userKeyword: '',
        taskKeyword: '',
        taskType: '',
        platform: '',
        appleIdMatchResult: '',
        order: 'asc',
      });
      setItems(result.items);
    } catch (e) {
      if (isApiError(e)) {
        setError(`请求失败 (${e.message})`);
      } else {
        setError('加载审核记录失败');
      }
    } finally {
      setLoading(false);
    }
  }, [taskId]);

  useEffect(() => {
    load();
  }, [load]);

  return { items, loading, error, reload: load };
}
